/**
 * @description Slider crossreading
 */

/* global SliderInt */

(() => {
	// GO 🚀
	const init = () => {
		return new SliderInt(
			'slide-int-crossreading-container',
			'crossreading',
			{ xl: 2, lg: 2, md: 2, sm: 1 }
		);
	};

	init();
})();
